import { combineReducers } from 'redux';
import {
  fetchRequirementsAction,
  fetchRequirementsSuccessAction,
} from '../actions/requirements';
import { createReducer } from 'redux-create-reducer';

const requirementReducer = field => {
  return createReducer([], {
    [fetchRequirementsSuccessAction]: (state, action) => {
      return action.payload[field].filter(i => !i.deleted);
    },
  });
};

const timeUnits = requirementReducer('timeUnits');
const housingTypes = requirementReducer('housingTypes');
const annexes = requirementReducer('annexes');
const products = requirementReducer('products');
const workers = requirementReducer('workers');
const soilTypes = requirementReducer('soilTypes');

const isFetching = createReducer(false, {
  [fetchRequirementsAction]: (state, action) => {
    return true;
  },
  [fetchRequirementsSuccessAction]: (state, action) => {
    return false;
  },
});

const requirements = combineReducers({
  isFetching,
  housingTypes,
  annexes,
  products,
  workers,
  timeUnits,
  soilTypes,
});

export default requirements;

export const getHousingTypes = state => state.requirements.housingTypes;
export const getAnnexes = state => state.requirements.annexes;
export const getProducts = state => state.requirements.products;
export const getWorkers = state => state.requirements.workers;
export const getTimeUnits = state => state.requirements.timeUnits;
export const getSoilTypes = state => state.requirements.soilTypes;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-study/reducers/requirements.js